"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = exports.SpinnerColors = exports.SpinnerBackgroundColors = exports.SpinnerSizes = exports.SpinnerTypeOptions = void 0;
var react_1 = __importDefault(require("react"));
var techsee_base_component_1 = require("../_shared/techsee-base-component");
require("./styles.scss");
var SpinnerTypeOptions;
(function (SpinnerTypeOptions) {
    SpinnerTypeOptions["DASH"] = "dash";
    SpinnerTypeOptions["CIRCULAR"] = "circular";
})(SpinnerTypeOptions = exports.SpinnerTypeOptions || (exports.SpinnerTypeOptions = {}));
var SpinnerSizes;
(function (SpinnerSizes) {
    SpinnerSizes["XLarge"] = "xlarge";
    SpinnerSizes["Large"] = "large";
    SpinnerSizes["Medium"] = "medium";
    SpinnerSizes["Small"] = "small";
    SpinnerSizes["XSmall"] = "xsmall";
})(SpinnerSizes = exports.SpinnerSizes || (exports.SpinnerSizes = {}));
var SpinnerBackgroundColors;
(function (SpinnerBackgroundColors) {
    SpinnerBackgroundColors["Default"] = "default";
    SpinnerBackgroundColors["Transparent"] = "transparent";
    SpinnerBackgroundColors["White"] = "white";
    SpinnerBackgroundColors["Blue"] = "blue";
    SpinnerBackgroundColors["Green"] = "green";
    SpinnerBackgroundColors["Yellow"] = "yellow";
    SpinnerBackgroundColors["Grey"] = "grey";
    SpinnerBackgroundColors["LightGray"] = "lightgray";
})(SpinnerBackgroundColors = exports.SpinnerBackgroundColors || (exports.SpinnerBackgroundColors = {}));
var SpinnerColors;
(function (SpinnerColors) {
    SpinnerColors["Default"] = "default";
    SpinnerColors["Red"] = "red";
    SpinnerColors["LightBlue"] = "lightblue";
    SpinnerColors["White"] = "white";
    SpinnerColors["Blue"] = "blue";
    SpinnerColors["Orange"] = "orange";
    SpinnerColors["Green"] = "green";
    SpinnerColors["Yellow"] = "yellow";
    SpinnerColors["Grey"] = "grey";
    SpinnerColors["LightGray"] = "lightgray";
    SpinnerColors["VeryDarkGray"] = "verydarkgray";
})(SpinnerColors = exports.SpinnerColors || (exports.SpinnerColors = {}));
var Spinner = (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.renderInternal = function () {
        this.addCssClass('icon-spinner');
        this.addCssClass(this.props.className);
        this.addCssClass('backgroundColor-' + this.props.backgroundColorName);
        this.addCssClass('size-' + this.props.sizeName);
        this.addCssClass('color-' + this.props.colorName);
        this.addCssClassIf('circular', this.props.spinnerType === SpinnerTypeOptions.CIRCULAR);
        return (react_1.default.createElement("div", { className: this.renderCssClasses() },
            react_1.default.createElement("div", { className: 'spinner-animation', style: { width: '100%', height: '100%' } },
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null))));
    };
    Spinner.defaultProps = {
        spinnerType: SpinnerTypeOptions.DASH,
        sizeName: SpinnerSizes.Small,
        backgroundColorName: SpinnerBackgroundColors.Default,
        colorName: SpinnerColors.Default
    };
    return Spinner;
}(techsee_base_component_1.TechseeBaseComponent));
exports.Spinner = Spinner;

//# sourceMappingURL=index.js.map
